import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import Logo from "../Logo";

export const WHATSAPP_SUPPORT = {
    display: "+1 (939) 938-9485",
    href: "https://wa.me/19399389485",
};

export default function PublicFooter() {
    return (
        <footer className="border-t border-avx-line mt-24 bg-avx-bg" data-testid="public-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
                <div>
                    <Logo to={null} className="mb-4" />
                    <p className="text-sm text-avx-muted leading-relaxed">
                        Your AVX Pro ecosystem to download and manage your professional plugins.
                    </p>
                    <div className="flex items-center gap-3 mt-5" data-testid="footer-socials">
                        <a
                            href="https://www.instagram.com/avxprochile/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            data-testid="footer-instagram"
                            className="w-10 h-10 rounded-sm border border-avx-line flex items-center justify-center text-avx-muted hover:text-white hover:border-avx-blue transition-colors"
                        >
                            <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
                                <path d="M12 2.2c3.2 0 3.6 0 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s0 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58 0-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.21 15.58 2.2 15.2 2.2 12s0-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.21 8.8 2.2 12 2.2Zm0 1.8c-3.14 0-3.5.01-4.74.07-.9.04-1.38.19-1.7.32-.43.16-.73.36-1.05.68-.32.32-.52.62-.68 1.05-.13.32-.28.8-.32 1.7C3.45 9.06 3.44 9.42 3.44 12s.01 2.94.07 4.18c.04.9.19 1.38.32 1.7.16.43.36.73.68 1.05.32.32.62.52 1.05.68.32.13.8.28 1.7.32 1.24.06 1.6.07 4.74.07s3.5-.01 4.74-.07c.9-.04 1.38-.19 1.7-.32.43-.16.73-.36 1.05-.68.32-.32.52-.62.68-1.05.13-.32.28-.8.32-1.7.06-1.24.07-1.6.07-4.18s-.01-2.94-.07-4.18c-.04-.9-.19-1.38-.32-1.7a2.8 2.8 0 0 0-.68-1.05 2.8 2.8 0 0 0-1.05-.68c-.32-.13-.8-.28-1.7-.32C15.5 4.01 15.14 4 12 4Zm0 3.06A4.94 4.94 0 1 1 7.06 12 4.94 4.94 0 0 1 12 7.06Zm0 1.8A3.14 3.14 0 1 0 15.14 12 3.14 3.14 0 0 0 12 8.86Zm5.14-3.2a1.15 1.15 0 1 1-1.15 1.15 1.15 1.15 0 0 1 1.15-1.15Z" />
                            </svg>
                        </a>
                        <a
                            href="https://www.tiktok.com/@avx.pro.chile"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="TikTok"
                            data-testid="footer-tiktok"
                            className="w-10 h-10 rounded-sm border border-avx-line flex items-center justify-center text-avx-muted hover:text-white hover:border-avx-blue transition-colors"
                        >
                            <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
                                <path d="M16.5 3h-2.9v12.1a2.3 2.3 0 1 1-2.3-2.3c.2 0 .5 0 .7.1v-3a5.3 5.3 0 1 0 4.6 5.2V8.9a6.3 6.3 0 0 0 3.7 1.2V7.2a3.6 3.6 0 0 1-2.5-1 3.6 3.6 0 0 1-1.3-3Z" />
                            </svg>
                        </a>
                    </div>
                </div>
                <div>
                    <div className="label-mono mb-4">Platform</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/plugins" className="hover:text-avx-blue">Catalog</Link></li>
                        <li><Link to="/desktop" className="hover:text-avx-blue">AVX Central</Link></li>
                        <li><Link to="/login" className="hover:text-avx-blue">Log in</Link></li>
                        <li><Link to="/register" className="hover:text-avx-blue">Create account</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-mono mb-4">Compatibility</div>
                    <ul className="space-y-2 text-sm font-mono text-avx-muted">
                        <li>VST3 / AU / AAX</li>
                        <li>Windows 10/11 · 64-bit</li>
                        <li>macOS 11+ · Apple Silicon</li>
                    </ul>
                </div>
                <div>
                    <div className="label-mono mb-4">Support</div>
                    <p className="text-sm text-avx-muted">
                        Create a ticket from your dashboard for technical support, installation, activation or sales inquiries.
                    </p>
                    <a
                        href={WHATSAPP_SUPPORT.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-whatsapp-support"
                        className="mt-4 inline-flex items-center gap-2 px-3 py-2 rounded-sm border border-[#25D366]/40 bg-[#25D366]/10 text-[#25D366] hover:bg-[#25D366]/20 transition-colors text-sm font-mono"
                    >
                        <MessageCircle className="w-4 h-4" />
                        WhatsApp support · {WHATSAPP_SUPPORT.display}
                    </a>
                </div>
            </div>
            <div className="border-t border-avx-line">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between text-xs text-avx-muted font-mono">
                    <span>© {new Date().getFullYear()} AVX Pro · All rights reserved</span>
                    <span className="uppercase tracking-[0.2em]">Mixing · Mastering · Live</span>
                </div>
            </div>
        </footer>
    );
}
